import { render, staticRenderFns } from "./CustomFormTypeEdit.vue?vue&type=template&id=3a1ddae6"
import script from "./CustomFormTypeEdit.js?vue&type=script&lang=js&external"
export * from "./CustomFormTypeEdit.js?vue&type=script&lang=js&external"
import style0 from "./CustomFormTypeEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports